import XandrAPI from './XandrAPI'
import WebAPI from './WebAPI'
import { find } from 'lodash'

const API_V2_ROOT = process.env.API_V2_ROOT
const LAS_CONFIG_PATHS = ['amrld/household', 'amrld/respondent', 'amrld/programs', 'ncs', 'mri']
const v2API = new WebAPI({ baseURL: API_V2_ROOT })

/**
 *
 * @returns {Promise} - returns a promise that resolves to an array of traits
 */
const getSegmentationTraits = async function (traitTypes) {
  if (!traitTypes) {
    const resp = await XandrAPI.getDatasourcesConfig()
    traitTypes = resp.TRAIT_TYPE
  }
  const traitsPromise = Object.keys(traitTypes).map(key => {
    return XandrAPI.getSegmentationTraits(traitTypes[key])
  })
  return Promise.all(traitsPromise)
}
/**
 * shows, household, respondents, and shows will be shared under the same root for AMRLD
 * @param {} datasets
 */
const distributeAMRLDDatasets = function (datasets) {
  const AMRLD_DATASET_IDS = ['shows', 'household', 'respondent']
  const amrldDatasets = datasets.filter(x => AMRLD_DATASET_IDS.includes(x.id))
  const nonAmrldDatasets = datasets.filter(x => !AMRLD_DATASET_IDS.includes(x.id))
  const amrldDataset = {
    children: amrldDatasets,
    id: 'amrld',
    name: 'AMRLD',
  }
  nonAmrldDatasets.push(amrldDataset)
  return nonAmrldDatasets
}

const changeCatalinaToNCS = function (datasets) {
  for (let d of datasets) {
    if (d.name === 'Catalina') {
      d.name = 'NCS'
    }
  }
  return datasets
}

const sortDatasets = function (datasets) {
  datasets.sort((a, b) => {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  })
  return datasets
}

const fetchAllWorkbenchConfigs = function (traitTypes) {
  // fetchDatasetFamilies()
  const promises = LAS_CONFIG_PATHS.map(k =>
    v2API.__get({ extensionURL: `/Datasets/LAS/${k}` }).then(resp => resp.data),
  )
  return getSegmentationTraits(traitTypes).then(traits => {
    return Promise.all([...traits, ...promises])
      .then(distributeAMRLDDatasets)
      .then(changeCatalinaToNCS)
      .then(sortDatasets)
  })
}

const fetchDatasetFamilies = function () {
  return v2API.__get({ extensionURL: '/Datasets/mappings' }).then(resp => resp.data)
}

const getConfigFilesForConfigType = function (cfgKey) {
  return {
    async fetchConfig() {
      const path = cfgKey === 'las' ? `LAS/config` : `${cfgKey}`
      return v2API.__get({ extensionURL: `/Datasets/${path}` }).then(resp => resp.data)
    },
    fetchDatasets(datasets, datasetId) {
      const selectedDataset = (datasetId && find(datasets, { id: datasetId })) || []
      // load non optional datasets and append the selected dataset
      const keys = datasets
        .filter(dataset => !dataset.optional)
        .concat(selectedDataset)
        .map(d => d.id)
      const promises = keys.map(k => v2API.__get({ extensionURL: `/Datasets/LAS/${k}` }).then(resp => resp.data))
      return Promise.all(promises)
    },
  }
}

function extractFileName(url) {
  const parts = url.split('/')
  return `${parts[parts.length - 1]}.gz` // remove .gz suffix after all other envs have been updated and las/ad/sm-config.json files updated
}
export default {
  fetchAllWorkbenchConfigs,
  fetchDatasetFamilies,
  getConfigFilesForConfigType,
}



// WEBPACK FOOTER //
// ./src/app/api/ConfigAPI.js